import { Card } from '@components/primitives/Card.js'
import { Spinner } from '@components/primitives/Spinner.js'
import { useStorageReport } from '@hooks/useStorageReport.js'
import { formatBytes, storageLevelMessage } from '@services/storageStats.js'

export function StorageSection() {
  const { report, loading, refresh } = useStorageReport()

  return (
    <Card surface='raised'>
      <div className='cf3-config-section'>
        <div className='cf3-config-section__header'>
          <p className='cf3-config-section__title'>Espaço no aparelho</p>
          <button
            type='button'
            className='cf3-config-section__link'
            onClick={() => void refresh()}
            disabled={loading}
          >
            Atualizar
          </button>
        </div>

        {loading && !report ? (
          <Spinner label='Calculando uso…' />
        ) : report ? (
          <>
            {report.percentUsed != null && (
              <div className='cf3-storage-meter'>
                <div className='cf3-storage-meter__labels'>
                  <span>Uso total do app</span>
                  <span>
                    {formatBytes(report.usageBytes ?? 0)}
                    {report.quotaBytes ? ` / ${formatBytes(report.quotaBytes)}` : ''}
                    {report.percentUsed != null ? ` (${report.percentUsed}%)` : ''}
                  </span>
                </div>
                <div
                  className={`cf3-storage-meter__track cf3-storage-meter__track--${report.level}`}
                  role='progressbar'
                  aria-valuemin={0}
                  aria-valuemax={100}
                  aria-valuenow={report.percentUsed ?? 0}
                  aria-label='Uso de espaço no aparelho'
                >
                  <span
                    className='cf3-storage-meter__fill'
                    style={{ transform: `scaleX(${(report.percentUsed ?? 0) / 100})` }}
                  />
                </div>
              </div>
            )}

            <dl className='cf3-config-list'>
              <div className='cf3-config-list__item'>
                <dt>Documentos anexados</dt>
                <dd>
                  {report.documentosComArquivo} arquivo
                  {report.documentosComArquivo !== 1 ? 's' : ''} ·{' '}
                  {formatBytes(report.documentosBytes)}
                </dd>
              </div>
              <div className='cf3-config-list__item'>
                <dt>Registros da obra</dt>
                <dd>
                  {report.outrosBytes != null
                    ? formatBytes(report.outrosBytes)
                    : 'Estimativa indisponível'}
                </dd>
              </div>
            </dl>

            {storageLevelMessage(report.level) && (
              <p className={`cf3-config-storage-notice cf3-config-storage-notice--${report.level}`}>
                {storageLevelMessage(report.level)}
              </p>
            )}

            <p className='cf3-config-storage-notice'>
              Fotos e PDFs anexados ficam guardados neste aparelho. O espaço disponível depende do
              seu celular ou computador. Exporte um backup em Configurações para manter tudo em
              segurança.
            </p>
          </>
        ) : (
          <p className='cf3-config-storage-notice'>
            Não foi possível estimar o espaço usado neste aparelho.
          </p>
        )}
      </div>
    </Card>
  )
}
